module.exports = __webpack_public_path__ + "img/ic_cobertura.6450c37a.svg";